import React, { useState, useEffect } from "react";
import Header from "../components/global/Header";
import Footer from "../components/global/Footer";
import MemberList from "../components/others/MemberList";
import CopilotLayout from "../components/layout/CopilotLayout";
import CopilotActions from "../components/layout/CopilotActions";
import { useAiSettings } from "../contexts/AiSettingsContext";
import useLocalStorage from "../hooks/useLocalStorage";
import { createUpdateBusinessSheetData } from "../utils/businessSheetUtils";

const MemberListWithCopilot = ({
  businessSheetData,
  updateBusinessSheetData,
}) => {
  // Issue #72: AI が有効なときだけ Copilot のフックを呼ぶ
  const { aiEnabled } = useAiSettings();

  return (
    <>
      {aiEnabled && (
        <CopilotActions
          businessSheetData={businessSheetData}
          updateBusinessSheetData={updateBusinessSheetData}
        />
      )}
      <MemberList businessSheetData={businessSheetData} />
    </>
  );
};

const MemberListContainer = () => {
  const [businessSheetData, setBusinessSheetData] = useState(null);
  const { getValue, setValue } = useLocalStorage();

  useEffect(() => {
    console.log("get sheet for member list page");
    const data = getValue("businessSheetData");
    setBusinessSheetData(data);
  }, [getValue]);

  const updateBusinessSheetData = createUpdateBusinessSheetData(
    setBusinessSheetData,
    setValue
  );

  return (
    <>
      <Header />
      <CopilotLayout
        businessSheetData={businessSheetData || {}}
        updateBusinessSheetData={updateBusinessSheetData}
      >
        <MemberListWithCopilot
          businessSheetData={businessSheetData || {}}
          updateBusinessSheetData={updateBusinessSheetData}
        />
      </CopilotLayout>
      <Footer />
    </>
  );
};

export default MemberListContainer;